import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/shared/http.service';
import { environment } from 'src/environments/environment';
import { ErrorThreshold } from '../interfaces/error-threshold.interface';
import { ErrorThresholdParameters } from '../interfaces/error-threshold-parameters.interface';

@Injectable({
  providedIn: 'root'
})
export class ErrorThresholdService {
  constructor(private httpService: HttpService) { }

  createErrorThreshold(ErrorThreshold: ErrorThreshold): any {
    return this.httpService.post('ErrorThreshold', ErrorThreshold);
  }

  getErrorThreshold(deId: number): any {
    return this.httpService.get('ErrorThreshold/' + deId);
  }

  deleteErrorThreshold(deId: number): any {
    return this.httpService.delete('ErrorThreshold/' + deId);
  }

  deleteErrorThresholdParameter(id: number): any {
    return this.httpService.delete('ErrorThreshold/' + id + '/Parameter');
  }

  updateErrorThresholdParameter(errorThresholdParameter: ErrorThresholdParameters): any {
    return this.httpService.put('ErrorThreshold/' + errorThresholdParameter.id + '/Parameter', errorThresholdParameter);
  }
}
